import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "detail"]

  select(event) {
    const savedScrollY = window.scrollY
    const link = event.currentTarget
    const card = link.closest("[data-skill-wheel-target='icon']")

    this.iconTargets.forEach(icon => {
      const circle = icon.querySelector("div")
      if (circle) {
        circle.style.borderColor = "#cbd5e1"
        circle.style.boxShadow = ""
        circle.style.background = "#e2e8f0"
      }
    })

    if (card) {
      const circle = card.querySelector("div")
      if (circle) {
        circle.style.borderColor = "#cbd5e1"
        circle.style.boxShadow = "0 0 0 3px rgba(148,163,184,0.25)"
        circle.style.background = "#cbd5e1"
      }
    }

    if (this.hasDetailTarget) {
      this.detailTarget.addEventListener("turbo:frame-load", () => {
        window.scrollTo({ top: savedScrollY, behavior: "instant" })
      }, { once: true })
    }
  }

  close() {
    if (this.hasDetailTarget) {
      this.detailTarget.innerHTML = ""
    }
    this.iconTargets.forEach(icon => {
      const circle = icon.querySelector("div")
      if (circle) {
        circle.style.borderColor = "#cbd5e1"
        circle.style.boxShadow = ""
        circle.style.background = "#e2e8f0"
      }
    })
  }
}
